import React, { useEffect } from "react";

const Terms = () => {
  useEffect(() => {
    document.title = "Terms and Conditions - 10E Beauty";
  }, []);

  return (
    <div className="max-w-3xl mx-auto py-12 px-6 text-[#5c2f2f]">
      <h1 className="text-3xl font-bold mb-6 text-[#a25d5d]">Terms and Conditions</h1>

      <p className="mb-4">
        Welcome to 10E Beauty! These terms and conditions outline the rules and
        regulations for the use of our website and services. By accessing this
        site, you accept these terms in full.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Use of Website</h2>
      <p className="mb-4">
        You agree not to misuse this site or its services. Unauthorized use,
        including but not limited to fraud or tampering with site content, is
        strictly prohibited.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Products and Orders</h2>
      <p className="mb-4">
        We reserve the right to limit or refuse orders. Prices and availability
        are subject to change without notice.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Intellectual Property</h2>
      <p className="mb-4">
        All content, trademarks, and logos on this site are owned or licensed
        by 10E Beauty. You may not use them without written permission.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Limitation of Liability</h2>
      <p className="mb-4">
        We are not liable for any indirect or incidental damages resulting from
        the use or inability to use our services or website.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Changes to Terms</h2>
      <p className="mb-4">
        We may revise these terms at any time. Continued use of the site means
        you accept the updated terms.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Contact</h2>
      <p className="mb-12">
        For questions about these terms, please contact us at{" "}
        <a
          href="mailto:support@10ebeauty.com"
          className="text-[#a25d5d] underline hover:text-[#c37676]"
        >
          support@10ebeauty.com
        </a>
        .
      </p>
    </div>
  );
};

export default Terms;
